export default new class AgeConfirm {
  constructor() {
    this.handler();
  }

  handler() {
    var wrapper = $('.header__wrapper');
    var placeholder = $('.header__placeholder');
    var scrollPrev = 0;
    var height = wrapper.height();

    $(window).scroll(function () {
      var scrolled = $(window).scrollTop();

      if (scrolled > 100 && scrolled > scrollPrev) {
        wrapper.addClass('header__out');
      } else {
        wrapper.removeClass('header__out');
      }
      scrollPrev = scrolled;

      if (scrolled > 0) {
        wrapper.addClass('header__fixed');
        placeholder.css('height', height)
      } else {
        wrapper.removeClass('header__fixed');
        placeholder.css('height', '')
      }
    });
  }
}();
